import React, { useEffect, useState } from 'react';
import styles from './Styles/Users.module.css';
import { getUsers, banUser, updateUser, unbanUser } from '../../Services/arndAPI';
import Loader from '../../Components/Loader/Loader';
import ConfirmModal from '../../Components/ConfirmModal/ConfirmModal';
import AttendeePhotosModal from '../../Components/AttendeePhotosModal/AttendeePhotosModal';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [showPhotosModal, setShowPhotosModal] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [modalAttendeeName, setModalAttendeeName] = useState('');
  const [filters, setFilters] = useState({
    role: '',
    fullName: '',
    phoneNumber: '',
    email: '',
    attendeeName: '',
  });
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState('');
  const [showConfirmBan, setShowConfirmBan] = useState(false);
  const [showConfirmUnban, setShowConfirmUnban] = useState(false);
  const [userToBan, setUserToBan] = useState(null);
  const [editingUser, setEditingUser] = useState(null);
  const [editForm, setEditForm] = useState({ fullName: '', phoneNumber: '', email: '', role: '' });
  const handleEditUser = (user) => {
    setEditingUser(user.id);
    setEditForm({
      fullName: user.fullName || '',
      phoneNumber: user.phoneNumber || '',
      email: user.email || '',
      role: user.role || '',
    });
  };

  const handleEditFormChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleUpdateUser = async (e, userId) => {
    e.preventDefault();
    setStatus('Updating user...');
    try {
      await updateUser(userId, editForm);
      setStatus('User updated successfully.');
      setEditingUser(null);
      fetchUsers();
    } catch {
      setStatus('Error updating user.');
    }
  };

  const handleCancelEdit = () => {
    setEditingUser(null);
  };

  const fetchUsers = async () => {
    setLoading(true);
    setStatus('');
    try {
      const data = await getUsers(filters);
      setUsers(data);
    } catch (err) {
      setStatus('Error loading users.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestBan = (userId) => {
    setUserToBan(userId);
    setShowConfirmBan(true);
  };

  const handleRequestUnban = async (userId) => {
    setUserToBan(userId);
    setShowConfirmUnban(true);
  };

  const confirmBan = async () => {
    try {
      await banUser(userToBan);
      setStatus('User banned successfully');
      fetchUsers();
    } catch {
      setStatus('Error banning user.');
    } finally {
      setShowConfirmBan(false);
      setUserToBan(null);
    }
  };

  const confirmUnban = async () => {
    try {
      await unbanUser(userToBan);
      setStatus('User unbanned successfully');
      fetchUsers();
    } catch {
      setStatus('Error banning user.');
    } finally {
      setShowConfirmUnban(false);
      setUserToBan(null);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchUsers();
  };

  return (
    <div className={styles.container}>
      {showConfirmBan && (
        <ConfirmModal
          message="Are you sure you want to ban this user?"
          onConfirm={confirmBan}
          onCancel={() => setShowConfirmBan(false)}
        />
      )}
      {showConfirmUnban && (
        <ConfirmModal
          message="Are you sure you want to unban this user?"
          onConfirm={confirmUnban}
          onCancel={() => setShowConfirmUnban(false)}
        />
      )}
      <h2>Manage Users</h2>

      <form className={styles.filters} onSubmit={handleSearch}>
        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={filters.fullName}
          onChange={handleFilterChange}
        />
        <input
          type="text"
          name="phoneNumber"
          placeholder="Phone Number"
          value={filters.phoneNumber}
          onChange={handleFilterChange}
        />
        <input
          type="text"
          name="email"
          placeholder="Email"
          value={filters.email}
          onChange={handleFilterChange}
        />
        <input
          type="text"
          name="attendeeName"
          placeholder="Attendee Name"
          value={filters.attendeeName}
          onChange={handleFilterChange}
        />
        <select name="role" value={filters.role} onChange={handleFilterChange}>
          <option value="">All Roles</option>
          <option value="ADMIN">Admin</option>
          <option value="PHOTOGRAPHER">Photographer</option>
          <option value="PARENT">Parent</option>
        </select>
        <button type="submit">Search</button>
      </form>

      {loading ? (
        <Loader />
      ) : (
        <div className={styles.cardGrid}>
          {users.map(user => (
            <div key={user.id} className={styles.userCard}>
              {editingUser === user.id ? (
                <form onSubmit={(e) => handleUpdateUser(e, user.id)} className={styles.editForm}>
                  <div className={styles.cardHeader}>
                    <h3>Edit User</h3>
                    <span className={`${styles.roleBadge} ${styles[editForm.role.toLowerCase()]}`}>{editForm.role}</span>
                  </div>
                  <label>
                    Full Name:
                    <input
                      type="text"
                      name="fullName"
                      value={editForm.fullName}
                      onChange={handleEditFormChange}
                    />
                  </label>
                  <label>
                    Email:
                    <input
                      type="email"
                      name="email"
                      value={editForm.email}
                      onChange={handleEditFormChange}
                    />
                  </label>
                  <label>
                    Phone:
                    <input
                      type="text"
                      name="phoneNumber"
                      value={editForm.phoneNumber}
                      onChange={handleEditFormChange}
                    />
                  </label>
                  <label>
                    Role:
                    <select name="role" value={editForm.role} onChange={handleEditFormChange}>
                      <option value="ADMIN">Admin</option>
                      <option value="PHOTOGRAPHER">Photographer</option>
                      <option value="PARENT">Parent</option>
                    </select>
                  </label>
                  <div style={{ marginTop: '1rem', display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
                    <button type="submit" className={styles.saveBtn}>Save</button>
                    <button type="button" className={styles.cancelBtn} onClick={handleCancelEdit}>Cancel</button>
                  </div>
                </form>
              ) : (
                <>
                  <div className={styles.cardHeader}>
                    <h3>{user.fullName || 'No Name'}</h3>
                    <span className={`${styles.roleBadge} ${styles[user.role.toLowerCase()]}`}>{user.role}</span>
                  </div>
                  <p><strong>Email:</strong> {user.email}</p>
                  <p><strong>Phone:</strong> {user.phoneNumber || 'N/A'}</p>
                  <p><strong>Email Confirmed:</strong> {user.profileIsSet ? '✅' : '❌'}</p>
                  <p><strong>Created:</strong> {new Date(user.createdAt).toLocaleDateString()}</p>
                  <div className={styles.attendees}>
                    <strong>Attendees:</strong>
                    {user.Attendees?.length ? (
                      <ul>
                        {user.Attendees.map(a => (
                          <li
                            key={a.id}
                            style={{ cursor: a.AttendeePhotos?.length ? 'pointer' : 'default', color: a.AttendeePhotos?.length ? '#2563eb' : undefined }}
                            onClick={() => {
                              if (a.AttendeePhotos?.length) {
                                setModalImages(a.AttendeePhotos);
                                setModalAttendeeName(a.fullName);
                                setShowPhotosModal(true);
                              }
                            }}
                          >
                            {a.fullName}
                          </li>
                        ))}
                      </ul>
                    ) : <span>None</span>}
                  </div>
                  {user.banned ? (
                    <button
                      className={styles.banBtn}
                      onClick={() => handleRequestUnban(user.id)}
                    >
                      Unban
                    </button>
                  ) : (
                    <button
                      className={styles.banBtn}
                      onClick={() => handleRequestBan(user.id)}
                    >
                      Ban
                    </button>
                  )}
                  <button
                    className={styles.editBtn}
                    onClick={() => handleEditUser(user)}
                  >
                    Edit
                  </button>
                </>
              )}
            </div>
          ))}
        </div>
      )}
      {status && <div className={styles.status}>{status}</div>}
      {showPhotosModal && (
        <AttendeePhotosModal
          images={modalImages}
          attendeeName={modalAttendeeName}
          onClose={() => setShowPhotosModal(false)}
        />
      )}
    </div>
  );
}